import { render, staticRenderFns } from "./JournalEditPage.vue?vue&type=template&id=a72213fc"
import script from "./JournalEditPage.vue?vue&type=script&lang=js"
export * from "./JournalEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports